import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.primary.dark};
`;

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Box)`
  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  gap: 100px;

  width: 100%;
  height: 62px;

  border-top: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;
